export default {
  exclusions: [],
  params: {
    contact_id: null,
    warehouse_id: null,
    product_id: null,
  },
};
